import { prop } from 'ramda';
import { useMemo } from 'react';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

export const useWebContentUrl = ({ webContentId, url }) => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const lang = useUserSelector(prop('lang'));
    const requestStamp = useAppSelector(prop('requestStamp'));

    return useMemo(() => {
            if (url) {
                return url;
            }

            if (!webContentId || !lang) {
                return null;
            }

            return getCMSResourceURL(`/webContent/${lang}_${webContentId}`, { t: requestStamp || Date.now() });
        },
        [getCMSResourceURL, webContentId, url, requestStamp, lang]
    );
};
